$(function(){

	var $win = $(window);
	var winW = function(){
		return $win.width();
	}
	var winH = function(){
		return $win.height();
	}
	var $side = $('.box-side');
	var $openMenu = $('.btn-menu');
	var $closeMenu = $('.btn-close');
	var $footer = $('.footer');
	var $main = $('.main');
	var $comment = $('.comment');
	var $boxComment = $('.box-comment');
	var $closeComment = $('.comment-close');
	var $wrapper = $('#wrapper');
	var $wrapYoutube = $('.wrap-youtube');
	var $youtube = $('.youtube-inner');
	var $btnYoutube = $('.btn-youtube');

	$wrapper.addClass('show');

	$openMenu.click(function(){
		$openMenu.addClass('hide');
		$closeMenu.removeClass('hide');

		$('body,html').animate({scrollTop:0}, 500, 'easeInOutQuart',function(){
			$('.page-home .header-logo').fadeIn();
			var headerH = $('.header').outerHeight(true);
			if(headerH < winH()){
				headerH = winH();
			}
			$side.height(headerH);
			$wrapper.addClass('hfix').height(headerH-60);
		});

		// $('html,body').css({
		// 	overflow:'hidden'
		// });
		// $footer.addClass('nav-open');
		// $main.addClass('nav-open');
	});

	$closeMenu.click(function(){
		$('.page-home .header-logo').fadeOut();

		$closeMenu.addClass('hide');
		$openMenu.removeClass('hide');
		$side.removeClass('open');
		// $('html,body').css({
		// 	overflow:'visible'
		// });

		if($('body').hasClass('page-home')){
			$side.height(0);
		}else{
			$side.height(60);			
		}
		$wrapper.removeClass('hfix').height('auto');


		// $footer.removeClass('nav-open');
		// $main.removeClass('nav-open');
	});

	if($comment.length > 0){
		$comment.click(function(){
			var target = ".box-comment." + $(this).data('comment');
			// var tempH = $main.height() + $footer.height() + 10;
			// if(winH() > tempH) {
			// 	var setH = winH();
			// }else {
			// 	var setH = tempH;
			// }
			// $(target).height(setH).addClass('show').fadeIn();
			$('body,html').animate({scrollTop:0}, 500, 'easeInOutQuart',function(){
				// $(target).addClass('show').fadeIn(function(){
				// 	var setH = $(target).outerHeight(true) - 60;
				// 	$wrapper.css({
				// 		height: setH,
				// 		overflow: 'hidden'
				// 	});
				// });

				var tempH = $wrapper.height() + 60;
				if(winH() > tempH) {
					var setH = winH();
				}else {
					var setH = tempH;
				}
				$(target).height(setH).addClass('show').fadeIn();


			});


		});

		$closeComment.click(function(){
			$wrapper.css({
				height: 'auto',
				overflow: 'visible'
			});
			$('.box-comment.show').fadeOut();
		});
	}
	
	if($('.entry-list').length > 0){
		entryListLink();
	}

	function entryListLink(){
		$('.entry-list').each(function(){
			var entryLink = $(this).find('a').attr('href');
			$(this).on('click',function(){
				location.href = entryLink;
			})
		});
	}


	// 登場人物
	var $charactor = $('#box-charactor');
	if($charactor.length > 0){
		var $thumb = $('.thumbs-charactor');

		var hash = location.hash;
		if(hash == ""){
			hash = "harada";
			$('.thumbs-harada').addClass('current')
			charaChange();
		}else{
			hash = hash.split('#');
			var targetThumb = ".thumbs-"+hash[1];
			$(targetThumb).addClass('current')
			charaChange();
		}

		var $thumb = $('.thumbs-charactor');

		$thumb.click(function(){
			if(!$(this).hasClass('current')){
				$thumb.removeClass('current');
				$(this).addClass('current');
				location.hash = $(this).data('hash');
			}
		});

		function charaChange(){
			$('.box-chara-inner').removeClass('show');
			if($('.thumbs-harada').hasClass('current')){
				$('.box-harada').addClass('show');
			}else if($('.thumbs-nagakura').hasClass('current')){
				$('.box-nagakura').addClass('show');
			}else if($('.thumbs-seiha').hasClass('current')){
				$('.box-seiha').addClass('show');
			}else if($('.thumbs-kadowaki').hasClass('current')){
				$('.box-kadowaki').addClass('show');
			}else if($('.thumbs-mizugaki').hasClass('current')){
				$('.box-mizugaki').addClass('show');
			}else if($('.thumbs-kaionji').hasClass('current')){
				$('.box-kaionji').addClass('show');
			}else if($('.thumbs-sawaguchi').hasClass('current')){
				$('.box-sawaguchi').addClass('show');
			}else if($('.thumbs-higashidani').hasClass('current')){
				$('.box-higashidani').addClass('show');
			}else if($('.thumbs-nobunishi').hasClass('current')){
				$('.box-nobunishi').addClass('show');
			}else if($('.thumbs-tomura').hasClass('current')){
				$('.box-tomura').addClass('show');
			}else if($('.thumbs-yoshisada').hasClass('current')){
				$('.box-yoshisada').addClass('show');
			}
			sceneChange();

		}

		window.addEventListener("hashchange", charaChange, false);


		// $thumb.click(function(){
		// 	if(!$(this).hasClass('current')){
		// 		$thumb.removeClass('current');
		// 		$(this).addClass('current');

		// 		$('.box-chara-inner').removeClass('show');

		// 		if($('.thumbs-harada').hasClass('current')){
		// 			$('.box-harada').addClass('show');
		// 		}else if($('.thumbs-nagakura').hasClass('current')){
		// 			$('.box-nagakura').addClass('show');
		// 		}else if($('.thumbs-seiha').hasClass('current')){
		// 			$('.box-seiha').addClass('show');
		// 		}else if($('.thumbs-kadowaki').hasClass('current')){
		// 			$('.box-kadowaki').addClass('show');
		// 		}else if($('.thumbs-mizugaki').hasClass('current')){
		// 			$('.box-mizugaki').addClass('show');
		// 		}else if($('.thumbs-kaionji').hasClass('current')){
		// 			$('.box-kaionji').addClass('show');
		// 		}else if($('.thumbs-sawaguchi').hasClass('current')){
		// 			$('.box-sawaguchi').addClass('show');
		// 		}else if($('.thumbs-higashidani').hasClass('current')){
		// 			$('.box-higashidani').addClass('show');
		// 		}

				
		// 	}
		// });

		var $arrowL = $('.btn-arrow-left');
		var $arrowR = $('.btn-arrow-right');

		$arrowL.click(function(){
			charChange(-1);
		});

		$arrowR.click(function(){
			charChange(1);
		});

		function charChange(_num){
			var $list = $('.box-chara-inner.show .charactor-list li');
			var listNum = $list.length;
			var currentNum = $list.index($('.box-chara-inner.show .charactor-list li.show'));
			var nextNum = currentNum + _num;
			if(nextNum == -1){
				nextNum = listNum -1;
			}else if(nextNum == listNum){
				nextNum = 0;
			}
			$list.removeClass('show');
			$list.eq(nextNum).addClass('show');
		}

		function sceneChange(){
			var $this = $('.box-chara-inner.show');
			var $list = $('.box-chara-inner.show .wrap-scene li');
			var listNum = $list.length;
			var nowNum = 0;
			if(listNum > 1){
				$list.removeClass('show');
				$list.eq(0).addClass('show');
				function sceneChangeloop(){
					setTimeout(function(){
						$list.eq(nowNum).removeClass('show');
						nowNum++;
						if(nowNum == listNum){
							nowNum = 0;
						}
						$list.eq(nowNum).addClass('show');
						if($this.hasClass('show')){
							sceneChangeloop();
						}
					},3000);
				}
				sceneChangeloop();
			}
			// var isFirst = $('.box-chara-inner.show').addClass('slide');
		}

		var startX;
		var diffX;
		var THRESHOLD = 30; // 閾値

		$('.wrap-chara').on("touchstart touchmove touchend", touchHandler);

		function touchHandler(e) {
		  var touch = e.originalEvent.touches[0];
		  if (e.type == "touchstart") {
		    startX = touch.pageX;
		  }
		  else if (e.type == "touchmove") {
		    diffX =  touch.pageX - startX ;

		    if(diffX < -5 || 5 < diffX ){
		      e.preventDefault();
		    }
		    if(-THRESHOLD < diffX && diffX < THRESHOLD){

		    }
		  } else if (e.type == "touchend") {
		    if (diffX > THRESHOLD) {
					charChange(1);
		    } else if (diffX < -THRESHOLD) {
					charChange(-1);
		    }
		    diffX = 0;
		    diffY = 0;
		  }
		}
	}

	////////////////////////////////
	// smooth scroll 

	$('a[href^=#]').click(function() {
	  var speed = 1000;
	  
	  var href= $(this).attr("href");
	  var target = $(href == "#" || href == "" ? 'html' : href);
	  var position = target.offset().top;

	  // if($('html').scrollTop() > 0){
	  //   var body = 'html';
	  // }else if($('body').scrollTop() > 0){
	  //   var body = 'body';
	  // }else{
	  //   return false;
	  // }

	  $('body,html').animate({scrollTop:position}, speed, 'easeInOutQuart');
	  return false;

	});
	
	// ブルーレイ
	// var $products = $('#box-products');
	// if($products.length > 0){

	// 	getHash();

	// 	function getHash(){
	// 		var hash = location.hash;
	// 		if(hash == ""){
	// 			hash = "product1";
	// 			$('.list-product1').addClass('current')
	// 			productChange(hash);
	// 		}else{
	// 			hash = hash.split('#');
	// 			var targetThumb = ".list-"+hash[1];
	// 			$(targetThumb).addClass('current')
	// 			productChange(hash[1]);
	// 		}			
	// 	}
		

	// 	var $thumb = $('.list-product li');

	// 	$thumb.click(function(){
	// 		if(!$(this).hasClass('current')){
	// 			$thumb.removeClass('current');
	// 			$(this).addClass('current');
	// 			// location.hash = $(this).find('a').attr('href');
	// 			// return false;
	// 		}
	// 	});

	// 	function productChange(_hash){
	// 		$('.box-product').removeClass('show');
	// 		var targetProduct = "#box-"+_hash;
	// 		$(targetProduct).addClass('show');

	// 		$products.height($(targetProduct).height());

	// 	}

	// 	window.addEventListener("hashchange", getHash, false);

	// }


});



